// extracted by mini-css-extract-plugin
export default {"MealSummaryRowTable":"CGMMealSummary_MealSummaryRowTable__k+oni","MealOptionsSummaryOverviewTable":"CGMMealSummary_MealOptionsSummaryOverviewTable__K7l6-"};